<template>
  <div class="form-page-wrapper">
    <div style="width: 500px">

      <el-form :model="form" :rules="rules" :hide-required-asterisk="true" ref="form"  >

        <el-form-item prop="appId">
          <template v-slot:label>
            <div class="form-item__label">应用编号</div>
          </template>
          <search-channel-app-select v-model="form.appId" @change-item="channelAppChange" style="width: 100%" />
        </el-form-item>

        <el-form-item prop="slotTypeId">
          <template v-slot:label>
            <div class="form-item__label">广告位类型</div>
          </template>
          <search-slot-type-select v-model="form.slotTypeId" @change-item="slotTypeChange" style="width: 100%" />
        </el-form-item>

        <el-form-item prop="slotName">
          <template v-slot:label>
            <div class="form-item__label">广告位名称</div>
          </template>
          <el-input v-model="form.slotName" :disabled="!inputSlotNameCheck"  placeholder="广告位名称" />
          <el-checkbox v-model="inputSlotNameCheck" @change="createSlotName()" style="position: absolute;top: 0;right: 0;line-height: 24px;">自定义名称</el-checkbox>
        </el-form-item>

        <el-form-item prop="slotDesc">
          <template v-slot:label>
            <div class="form-item__label">广告位简介</div>
          </template>
          <el-input v-model="form.slotDesc" type="textarea" placeholder="广告位简介" />
        </el-form-item>
      </el-form>

      <div style="text-align: center;">
        <el-button @click="toPage">返回</el-button>
        <el-button @click="submit" type="primary">提交</el-button>
      </div>

    </div>
  </div>
</template>

<script>
import SearchSlotTypeSelect from '@/components/SearchSlotTypeSelect'
import SearchChannelAppSelect from '@/components/SearchChannelAppSelect'

import { addAdChannel, updateAdChannel, getAdChannelDetail } from '@/api/advertise/channel'

const form = {
  slotId: undefined,
  slotName: "",
  slotTypeId: undefined,
  appId: undefined,
  slotDesc: undefined
}
export default {
  data () {
    return {
      form: form,
      inputSlotNameCheck: false,
      channelAppSelectItem: {},
      slotTypeSelectItem: {},
      rules: {
        slotName: [
          { required: true, message: '请输入广告位名称', trigger: 'change' }
        ],
        slotTypeId: [
          { required: true, message: '请选择广告位类型', trigger: 'change' }
        ],
        appId: [
          { required: true, message: '请选择渠道应用', trigger: 'change' }
        ],
        slotDesc: [
          { required: true, message: '请输入广告位简介', trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    SearchSlotTypeSelect,
    SearchChannelAppSelect
  },
  created () {
    this.getAdChannelDetail()
  },
  methods: {
    appChange (value) {
      this.form.appId = value
    },

    channelAppChange (item) {
      this.channelAppSelectItem = item
      this.createSlotName()
    },
    slotTypeChange (item) {
      this.slotTypeSelectItem = item
      this.createSlotName()
    },
    createSlotName () {
      if (!this.inputSlotNameCheck) {
        if (this.form.slotTypeId && this.form.appId) {
          this.form.slotName = `${this.channelAppSelectItem.appName}_${this.slotTypeSelectItem.label}`
        } else {
          this.form.slotName = ''
        }
      }
    },

    getAdChannelDetail () {
      if (!this.$route.query.slotId) return
      getAdChannelDetail({ slotId: this.$route.query.slotId }).then(res => {
        if (res.code === 200) {
          this.inputSlotNameCheck = true
          this.form = res.data
          setTimeout(() => {
            this.inputSlotNameCheck = false
          }, 0)
        }
      })
    },

    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form.slotId = this.$route.query.slotId || undefined
          if (!this.form.slotId) {
            addAdChannel(this.form).then(res => {
              if (res.code === 200) {
                this.resetForm()
                this.toPage()
              }
            })
          } else {
            updateAdChannel(this.form).then(res => {
              if (res.code === 200) {
                this.resetForm()
                this.toPage()
              }
            })
          }
        }
      })
    },
    resetForm () {
      this.$refs.form.resetFields()
      this.form = form
    },
    toPage () {
      this.form.slotName=""
      this.$router.push({ path: 'list' })
    }
  }
}
</script>

<style>
  .form-page-wrapper{
    padding: 20px;
    background: #ffffff;
  }
  .form-label{
    display: block;
    line-height: 20px;
  }

  .form-item__label{
    line-height: 24px;
  }
</style>
